import api from '@/axios';

export const getPurchaseOrderPdfPreview = async (id: string): Promise<Blob> => {
  const response = await api.get<Blob>(`/purchase-orders/${id}/pdf-preview`, {
    responseType: 'blob',
  });
  return response.data;
};
